import { TenantConfig, TenantConfigKeys } from './tenantConfigTypes';
import { useTypedSelector } from 'state';

export function useTenantConfig<T extends TenantConfigKeys>(key: T): [TenantConfig[T], boolean];
export function useTenantConfig<T extends TenantConfigKeys>(
  keys: T[]
): [Array<TenantConfig[T]>, boolean];

export function useTenantConfig(keys: TenantConfigKeys | TenantConfigKeys[]) {
  const { values: config, loadingConfigs } = useTypedSelector(state => state.tenantConfig);

  let values: TenantConfig[TenantConfigKeys] | Array<TenantConfig[TenantConfigKeys]>;
  let loading: boolean;

  if (Array.isArray(keys)) {
    values = keys.map(key => config[key]) as Array<TenantConfig[TenantConfigKeys]>;
    loading = keys.some(key => loadingConfigs.includes(key));
  } else {
    values = config[keys];
    loading = loadingConfigs.includes(keys);
  }

  return [values, loading];
}
